import { TopUpVFX } from '../../../../../../../app/scenes/game/vfx/topup/TopUpVFX';
import { getStarsInvoice } from '../../../../../../../app/backend/api/api';
import { ShopPosition } from '../../../../../../../types/alice-bob';
import Settings from '../../../../../..//settings/Settings';
import { purchase } from '../../../../../../../app/backend/store/shop';

const LABEL = {
    FONT: Settings.FONTS.LXGW_CYRILLIC_BOLD,
    SIZE: 38,
    TINT: 0xffffff,
    SHADOW: { OFFSET: 4, TINT: 0x000000, ALPHA: 0.5 },
};

export default class Entry extends Phaser.GameObjects.Container {
    private bg!: Phaser.GameObjects.Image;
    private bg_item!: Phaser.GameObjects.Image;
    private icon!: Phaser.GameObjects.Image;
    private price!: Phaser.GameObjects.BitmapText;

    constructor(scene: Phaser.Scene, x: number, y: number, offer: ShopPosition, vfx: TopUpVFX) {
        super(scene, x, y);

        this.setupBG(offer);
        this.setupIcon(offer);
        this.setupLabel(offer);

        this.bg_item.setInteractive({ useHandCursor: true });
        this.bg_item.on('pointerup', async () => {
            const paymentLink = await getStarsInvoice(offer.shop_id)

            window.Telegram.WebApp.openInvoice(paymentLink, async (data: any) => {
                if (data != "paid") return;
                vfx.showTime({ x: this.getWorldTransformMatrix().tx, y: this.getWorldTransformMatrix().ty });
                purchase(offer)
            }, this)
        });
    }

    private setupBG(offer: ShopPosition): void {
        this.bg_item = this.scene.add.image(0, 0, 'atlas', 'gui/popups/shop/bg_item');
        this.bg = this.scene.add.image(0, -30, 'atlas', 'shop/gem-bg');
        this.add([this.bg_item, this.bg]);
    }

    private setupIcon(offer: ShopPosition): void {
        const x = 0;
        const y = -30;
        const frame = 'shop/' + offer.shop_id;
        this.icon = this.scene.add.image(x, y, 'atlas', frame);

        const amount = this.scene.add.bitmapText(0, 0, LABEL.FONT, 'x' + offer.items[0].amount, LABEL.SIZE);
        amount.setOrigin(0.5, 0.5)

        this.add([this.icon, amount]);
    }

    private setupLabel(offer: ShopPosition): void {
        const x = 0;
        const y = 95;

        const starIcon = this.scene.add.image(x - 20, y, 'atlas', 'shop/stars');
        starIcon.setScale(0.8)
        this.price = this.scene.add.bitmapText(x + 20, y, LABEL.FONT, offer.price_amount + '', LABEL.SIZE);
        this.price.setOrigin(0.5);
        this.price.setTint(LABEL.TINT);
        this.price.setDropShadow(LABEL.SHADOW.OFFSET, LABEL.SHADOW.OFFSET, LABEL.SHADOW.TINT, LABEL.SHADOW.ALPHA);
        this.add([this.price, starIcon]);
    }
}
